(function () {
    'use strict';

    angular.module("imApp").factory("docCategoriesService", [function () {
        let service = {};

        return service;
    }]);
})();
